import React from "react";
import { graphql } from "gatsby";

import SearchPage from "../../components/Search";
import Layout from "../../components/layout";
import Breadcrumb from "../../components/Breadcrumb";

export default function Search({ data }) {
  return (
    <Layout
      meta={{
        ...data.wpPage.Meta,
        canonical: data.wpCourseProvider.uri,
      }}
      path={"data.wpCourseProvider.uri"}
      cta={"a"}
      themeOptions={data.wp.themeOptions}
    >
      <Breadcrumb
        type="page"
        current={{
          title: "Search results",
          slug: "search-results",
          uri: "/search",
        }}
      />
      <SearchPage
        brands={data.allWpBrand}
        state={{ query: data.wpCourseProvider.name, category: "training" }}
      />
    </Layout>
  );
}

export const query = graphql`
  query($id: String) {
    wpCourseProvider(id: { eq: $id }) {
      name
      uri
    }
    allWpBrand {
      edges {
        node {
          id
          name
          slug
        }
      }
    }
    wpPage(uri: { eq: "/" }) {
      id
      Meta {
        metaDescription
        metaTitle
        ogDescription
        ogTitle
        twitterCardType
        twitterDescription
        twitterTitle
      }
    }
    wp {
      themeOptions {
        ThemeOptions {
          siteLogo {
            mediaItemUrl
          }
        }
      }
    }
  }
`;
